export default __webpack_public_path__ + "static/media/payment2.aafe43db.webp";